export enum EAdsPlacement{
    HomePage='HomePage',
    SearchPage='SearchPage'
}